import * as firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = CONFIG.firebase_config;

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

function getFirebaseToken() {
    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            user.getIdToken(true).then(idToken => {
                performDeleteRequest(idToken);
            }).catch(error => {
                console.error("Error getting token:", error);
                throw error;
            });
        } else {
            console.log("No user logged in");
            throw new Error("No user logged in");
        }
    });
}

function performDeleteRequest(token) {
    $.ajax({
        url: '/wp-json/sport1/v1/user/delete/',
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'x-sport1-mobile-app': 'true'
        },
        success: function(response) {
            if (response['Deleted Favorites'] === true && response['Deleted WP Data'] === true) {
                window.location.href = '/';
            } else {
                console.log('Failed to delete account. Please try again.');
            }
        },
        error: function() {
            console.log('Error occurred. Please try again later.');
        }
    });
}

$(document).on('click', '#delete-acc-btn', function() {
    getFirebaseToken().catch(error => {
        console.log("Error:", error);
        console.log("You must be logged in to perform this action.");
    });
});
